import MultipleChoiceController from './multiple-choice-controller';
import MultipleMatchController from './multiple-match-controller';
import MultiMultipleChoiceController from './multi-multiple-choice-controller';
import FallingMatchController from './falling-match-controller';
import PickInSequenceController from './pick-in-sequence-controller';
import WhenQuestionWithNumberInputController from './when-question-with-number-input-controller';

export default class QuizSession {
    constructor(dataProvider, { lives = -1 }) {
        this.lives = lives;
        this.progress = 0;
        this.totalCount = 0;
        this.correctCount = 0;
        this.currentController = null;
        this.initialLives = lives;

        this.eventListeners = [];

        const controllerClassMap = {
            multipleChoice: MultipleChoiceController,
            multipleMatch: MultipleMatchController,
            multiMultipleChoice: MultiMultipleChoiceController,
            fallingMatch: FallingMatchController,
            pickInSequence: PickInSequenceController,
            whenQuestionWithNumberInput: WhenQuestionWithNumberInputController
        };

        this.controllers = [];
        dataProvider.items.forEach(item => {
            const ControllerClass = controllerClassMap[item.type];
            this.controllers.push(new ControllerClass(item, this));
        });

        this.controllers.forEach(c => {
            this.totalCount += c.totalCount;
        });

        // this.history = []
        this.queue = this.controllers.slice();
    }
    on(event, func) {
        this.eventListeners.push([event, func]);
    }
    off(event, func) {
        if (!event) {
            this.eventListeners = [];
        } else if (!func) {
            this.eventListeners = this.eventListeners.filter(([e, f]) => {
                return f !== func;
            });
        } else {
            this.eventListeners = this.eventListeners.filter(([e, f]) => {
                return e !== event && f !== func;
            });
        }
    }
    emit(eventType) {
        this.eventListeners.forEach(([eType, func]) => {
            if (eType === eventType) {
                func();
            }
        });
    }

    update() {
        const controllers = this.controllers;
        this.correctCount = 0;
        this.totalCount = 0;
        this.progress = 0;
        this.lives = this.initialLives;
        controllers.forEach(c => {
            this.correctCount += c.correctCount;
            this.totalCount += c.totalCount;
            this.progress += c.progress;
            this.lives -= c.failCount;
        });
        this.progress = this.progress / controllers.length;
        this.emit('update');
    }

    next() {
        // const livesGone = this.lives === 0
        if (this.lives === 0) {
            this.currentController = null;
            // return null
        } else if (this.currentController) {
            if (
                (this.currentController.unskippable || this.currentController.totalCount > 1) &&
                this.currentController.progress < 1
            ) {
                // return this.currentController // .subsession || this.currentController
            } else if (this.currentController.score === 0) {
                this.currentController.backInQueue = (this.currentController.backInQueue || 0) + 1;
                if (this.currentController.shuffle) {
                    this.currentController.shuffle();
                }
                this.queue.push(this.currentController);
                this.currentController = this.queue.shift() || null;
            } else {
                this.currentController = this.queue.shift() || null;
            }
        } else {
            this.currentController = this.queue.shift() || null;
        }

        if (!this.currentController) {
            this.emit('end');
        }
        return this.currentController;
    }

    getSummary() {
        const completedItems = [];
        const failedItems = [];

        this.controllers.forEach(c => {
            if (c.getSummary) {
                const summary = c.getSummary();
                completedItems.push(...summary.completedItems);
                failedItems.push(...summary.failedItems);
            }
        });

        return {
            success: this.totalCount === this.correctCount,
            totalCount: this.totalCount,
            correctCount: this.correctCount,
            completedItems,
            failedItems
        };
    }
}
